import _asyncToGenerator from "/portal/Vue/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/portal/Vue/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.regexp.to-string.js";
import "core-js/modules/es6.function.name.js";
/// ///////////////////////////////////////////////////////////////////////
//                 smacompany / Компании
/// ///////////////////////////////////////////////////////////////////////

import { i18n } from 'boot/i18n';
import { MODE, ENTRY } from 'pages/aftmixin';
import { aftInst as aft, systemError } from 'boot/aft';

// ----------------------------------------------------------------------------
//                               smaCompanyList
// Возвращает список компаний
// ----------------------------------------------------------------------------

export function smaCompanyList() {
  return _smaCompanyList.apply(this, arguments);
}
function _smaCompanyList() {
  _smaCompanyList = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var res;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!('smacompany' in aft.g.obj && aft.g.obj.smacompany.env.data.length)) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return", aft.g.obj.smacompany.env.data);
        case 2:
          if (!aft.g.smacompanyCash) {
            _context.next = 4;
            break;
          }
          return _context.abrupt("return", aft.g.smacompanyCash);
        case 4:
          _context.next = 6;
          return _getsmaCompanyList();
        case 6:
          res = _context.sent;
          aft.g.smacompanyCash = res;
          return _context.abrupt("return", res);
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _smaCompanyList.apply(this, arguments);
}
function _getsmaCompanyList() {
  return aft.postDbAction('smacompany', 'select', {}).then(function (response) {
    return response.data;
  }).catch(function (error) {
    systemError(error);
  });
}

// ----------------------------------------------------------------------------
//                               hashFnv32a
//
//  * Calculate a 32 bit FNV-1a hash
//  * Found here: https://gist.github.com/vaiorabbit/5657561
//  * Ref.: http://isthe.com/chongo/tech/comp/fnv/
// ----------------------------------------------------------------------------
export function hashFnv32a(str) {
  var i,
    l,
    hval = 0x811c9dc5;
  for (i = 0, l = str.length; i < l; i++) {
    hval ^= str.charCodeAt(i);
    hval += (hval << 1) + (hval << 4) + (hval << 7) + (hval << 8) + (hval << 24);
  }
  // Convert to 8 digit hex string
  return ('0000000' + (hval >>> 0).toString(16)).substr(-8);
}
export default {
  data: function data() {
    return {
      recAdd: {
        id: null,
        name: null,
        note: null,
        country: null,
        phone: null,
        email: null,
        url: null,
        logofileid: null
      },
      recRse: {
        Actual: 'Y'
      },
      aftobjDesc: {
        aftobjCode: 'smacompany',
        aftobjEntry: ENTRY.cardTab,
        aftobjMode: [MODE.inittab, MODE.recpage],
        aftchkFuncs: ['name'],
        aftobjActs: [
        // Row actions
        'actDelete',
        // Tool bar actions
        {
          act: 'actSelect',
          icon: 'cached',
          scope: 'none'
        }, {
          act: 'actAdd',
          icon: 'add',
          scope: 'none'
        }, {
          act: 'actUpdate',
          scope: 'none'
        },
        // для доступа
        {
          act: 'actFind',
          icon: 'search',
          scope: 'none'
        },
        // Table actions
        {
          act: 'actSwitchMarks',
          icon: '',
          scope: 'tab'
        }, {
          act: 'actDeleteM',
          icon: '',
          scope: 'tab'
        }, {
          act: 'actExcel',
          icon: '',
          scope: 'tab'
        }]
      }
    };
  },
  computed: {
    columns: function columns() {
      return [
      // { name: 'id', field: 'id', label: this.t('acsaccount.lab.id'), sortable: true },
      {
        name: 'aftRowActions',
        field: 'aftRowActions',
        /* label: this.t('com.lab.rowactions'), */sortable: false,
        align: 'left'
      }, {
        name: 'name',
        field: 'name',
        label: i18n.t('smaCustomer.name'),
        sortable: true,
        align: 'left',
        style: 'max-width: 200px',
        classes: 'ellipsis'
      }, {
        name: 'hexkey',
        field: 'hexkey',
        label: 'Hex key',
        sortable: false,
        align: 'left',
        format: function format(val, row) {
          return hashFnv32a(row.name);
        }
      }, {
        name: 'note',
        field: 'note',
        label: i18n.t('smaCustomer.note'),
        sortable: true,
        align: 'left',
        style: 'max-width: 300px',
        classes: 'ellipsis'
      }, {
        name: 'country',
        field: 'country',
        label: i18n.t('smaCustomer.country'),
        sortable: true,
        align: 'left'
      }, {
        name: 'phone',
        field: 'phone',
        label: i18n.t('smaCustomer.phone'),
        sortable: true,
        align: 'left'
      }, {
        name: 'email',
        field: 'email',
        label: 'Email',
        sortable: true,
        align: 'left'
      }, {
        name: 'url',
        field: 'url',
        label: i18n.t('smaCustomer.url'),
        sortable: true,
        align: 'left'
      }
      // { name: 'avaFileId', field: 'avaFileId', label: i18n.t('acsaccount.lab.ava'), sortable: false }
      ];
    }
  }
};